import { useNavigatedRoutes } from 'common/hooks';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { canFullscreen, toggleFullScreen } from 'utils';

// import VZIcon from 'assets/images/logo/vz-logo.png';
import GalleryMenu from 'components/GalleryMenu';
import {
  AudioIcon,
  AutoRotateIcon,
  BackToDefaultSceneButton,
  ContactFormIcon,
  ExpandIcon,
  FloorMapIcon,
  // GyroscopeIcon,
  // HelpIcon,
  MapFloorPlanIcon,
  MapIcon,
  // PinIcon,
} from 'components/icons';
// import { AutoPlayIcon } from 'components/icons/AutoPlayIcon';
import PanoMenu from 'components/panoMenu';

import SchoolLayoutIcons from 'components/MenuForDesktop/SchoolLayoutIcons';
import SchoolLayoutMenu from 'components/SchoolLayoutMenu';
import configs from 'configs';
import { LAYOUT_UI } from 'consts/ui.const';
import { setAutoPlay } from 'store/actions';
import { limitLetters } from 'utils/limitLetters';
import { backToDefaultScene } from 'containers/world/utils';
import MobileSimpleLayoutIcons from './MobileSimpleLayoutIcons';

const MenuForMobile = (props) => {
  const {
    menuList,
    isNavOpen,
    menuPosition,
    currentPano,
    // subTitle,
    showLanding,
    menuOpenScene,
    toggleRotate,
    toggleMenu,
    shouldRotate,
    handleSwitchControlMode,
    featuredMedia,
    color,
    isShowOnMap,
    isShowAudioIcon,
    tour,
    onSelect,
    groups,
    scenes,
    isShowMapFloorPlan,
    floorMaps,
    imageSize,
    setImageSize,
  } = props;

  const {
    tour: { enableGyroscope },
  } = useSelector((state) => state);
  const [handleUpdateRoute] = useNavigatedRoutes();
  const autoPlayMode = useSelector((state) => state.autoPlayMode);
  const [isAutoPlay, setIsAutoPlay] = useState(autoPlayMode);
  const [fullScreen, setFullScreen] = useState(false);
  const [isActiveMap, setIsActiveMap] = useState(false);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [mapShowed, setMapShowed] = useState();
  const isMenuGallery = useSelector(
    ({ searchParams }) => searchParams['menu-ui'] === 'gallery'
  );
  const [openMenu, setOpenMenu] = useState(
    !(tour.menuStyle === LAYOUT_UI.SCHOOL)
  );

  const isVerticalImage = useMemo(
    () => imageSize.height > imageSize.width,
    [imageSize]
  );

  useEffect(() => {
    setOpenDropDown(false);
  }, [currentPano]);

  // const autoRotateSpeed = useSelector((state) => state.tour.autoRotateSpeed);

  const shouldShowMapIcon = useMemo(
    () =>
      tour.mapCoordinates.length > 0 &&
      !(tour.mapCoordinates[0] === 0 && tour.mapCoordinates[1] === 0),
    [tour]
  );

  const isSchoolLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.SCHOOL,
    [tour]
  );

  const isBrotherFurnitureLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.BROTHERS_FURNITURE,
    [tour]
  );

  const isSimpleLayout = useMemo(
    () => tour.menuStyle === LAYOUT_UI.SIMPLE,
    [tour]
  );

  const mediaMap2D = useMemo(
    () =>
      currentPano?.hotspots
        .map((hs) =>
          hs.media?.type === 'MapFloorPlan' && hs.media.mapFloorPlan.length
            ? hs.media
            : null
        )
        .filter((el) => el !== null)[0] || null,
    [currentPano]
  );

  const toggleHelpButton = () => {
    showLanding();
  };

  const dispatch = useDispatch();

  const switchMode = useCallback(() => {
    setIsAutoPlay(!isAutoPlay);
    dispatch(setAutoPlay(!isAutoPlay));
  }, [dispatch, isAutoPlay]);

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleFullScreen = () => {
    toggleFullScreen();
    setFullScreen(!fullScreen);
  };

  const handleSelectMap = (item) => {
    setMapShowed(item);
  };

  useEffect(() => {
    if (floorMaps.length > 0 && currentPano) {
      const getCurrentMap = (floorMaps, pano) => {
        return floorMaps.find((item) =>
          item.objects.length
            ? item.objects.some((obj) => obj.id === pano._id)
            : item
        );
      };

      const intialMap = getCurrentMap(floorMaps, currentPano);

      setMapShowed(intialMap);
    }
  }, [currentPano, floorMaps]);

  return (
    <>
      <div className={`menuV2-mobile--container`}>
        <div
          className={`menuV2-mobile--icons ${isNavOpen ? 'navMenuOpen' : ''}`}
        >
          {/* {!isSchoolLayout && !isSimpleLayout && (
            <div className="vz-logo">
              <img alt="vz-logo" src={VZIcon}></img>
            </div>
          )} */}
          {isSchoolLayout && (
            <SchoolLayoutIcons
              currentPano={currentPano}
              isAutoPlay={isAutoPlay}
              color={color}
              toggleHelpButton={toggleHelpButton}
              featuredMedia={featuredMedia}
              isShowAudioIcon={isShowAudioIcon}
              toggleRotate={toggleRotate}
              shouldRotate={shouldRotate}
              canFullscreen={canFullscreen}
              menuPosition={menuPosition}
              handleFullScreen={handleFullScreen}
              fullScreen={fullScreen}
              isShowMapFloorPlan={isShowMapFloorPlan}
              setIsActiveMap={setIsActiveMap}
              isActiveMap={isActiveMap}
              mapShowed={mapShowed}
              setOpenDropDown={setOpenDropDown}
              openDropDown={openDropDown}
              handleSelectMap={handleSelectMap}
              scenes={scenes}
              onSelect={onSelect}
              switchMode={switchMode}
              handleUpdateRoute={handleUpdateRoute}
              openMenu={openMenu}
              isSchoolLayout={isSchoolLayout}
              enableGyroscope={enableGyroscope}
              handleSwitchControlMode={handleSwitchControlMode}
            />
          )}

          {isSimpleLayout && (
            <MobileSimpleLayoutIcons
              currentPano={currentPano}
              isAutoPlay={isAutoPlay}
              color={color}
              toggleHelpButton={toggleHelpButton}
              featuredMedia={featuredMedia}
              isShowAudioIcon={isShowAudioIcon}
              toggleRotate={toggleRotate}
              shouldRotate={shouldRotate}
              canFullscreen={canFullscreen}
              menuPosition={menuPosition}
              handleFullScreen={handleFullScreen}
              fullScreen={fullScreen}
              isShowMapFloorPlan={isShowMapFloorPlan}
              setIsActiveMap={setIsActiveMap}
              isActiveMap={isActiveMap}
              mapShowed={mapShowed}
              setOpenDropDown={setOpenDropDown}
              openDropDown={openDropDown}
              handleSelectMap={handleSelectMap}
              scenes={scenes}
              onSelect={onSelect}
              switchMode={switchMode}
              handleUpdateRoute={handleUpdateRoute}
              openMenu={openMenu}
              isSchoolLayout={isSchoolLayout}
              enableGyroscope={enableGyroscope}
              handleSwitchControlMode={handleSwitchControlMode}
              isVerticalImage={isVerticalImage}
              mediaMap2D={mediaMap2D}
              setImageSize={setImageSize}
              floorMaps={floorMaps}
              isSimpleLayout={isSimpleLayout}
            />
          )}

          {!isSchoolLayout && !isSimpleLayout && (
            <div
              className={`icons ${
                openMenu && (isMenuGallery || isSchoolLayout)
                  ? 'translateY'
                  : ''
              }`}
            >
              {isBrotherFurnitureLayout && (
                <div
                  className={`icons_icon`}
                  onClick={() => backToDefaultScene(menuList, scenes, onSelect)}
                >
                  <BackToDefaultSceneButton
                    menuList={menuList}
                    currentPano={currentPano}
                  />
                </div>
              )}

              {/* <div
                className="icons_icon"
                onClick={() => {
                  switchMode();
                }}
              >
                <AutoPlayIcon shouldRotate={isAutoPlay} activeColor={color} />
              </div>
              <div className="icons_icon" onClick={toggleHelpButton}>
                <HelpIcon />
              </div> */}
              {shouldShowMapIcon && (
                <div
                  className="icons_icon"
                  style={{
                    display: isShowOnMap ? 'flex' : 'none',
                  }}
                  onClick={() => handleUpdateRoute(configs.mapRoute)}
                >
                  <MapIcon />
                </div>
              )}

              {featuredMedia.map && (
                <div
                  className="icons_icon icon-floor"
                  onClick={() => handleUpdateRoute(featuredMedia.map.id)}
                >
                  <FloorMapIcon />
                </div>
              )}

              {featuredMedia.contact && (
                <div
                  className="icons_icon"
                  onClick={() => handleUpdateRoute(featuredMedia.contact.id)}
                >
                  <ContactFormIcon />
                </div>
              )}

              {isShowAudioIcon && (
                <AudioIcon activeColor={color} className="icons_icon" />
              )}
              <div
                className="icons_icon"
                onClick={() => {
                  toggleRotate();
                }}
              >
                <AutoRotateIcon
                  shouldRotate={shouldRotate}
                  activeColor={color}
                />
              </div>

              {/* {enableGyroscope && (
                <div className="icons_icon" onClick={handleSwitchControlMode}>
                  <GyroscopeIcon activeColor={color} />
                </div>
              )} */}

              {isShowMapFloorPlan && (
                <>
                  <div
                    className="icons_icon position-relative"
                    onClick={() => setIsActiveMap(!isActiveMap)}
                  >
                    <MapFloorPlanIcon active={isActiveMap} />
                  </div>
                  <div
                    className={`mapfloorplan_container ${
                      isVerticalImage ? 'vertical-image' : ''
                    } ${
                      isActiveMap
                        ? `open ${
                            isVerticalImage ? 'open-vertical--image' : ''
                          }`
                        : ''
                    }`}
                  >
                    {mapShowed && (
                      <>
                        {floorMaps.length > 1 && (
                          <div className="map_header">
                            <div
                              className="map_dropdown"
                              onClick={() => setOpenDropDown(!openDropDown)}
                            >
                              <span>
                                {limitLetters(mapShowed.image.name, 15)}
                              </span>
                              <i className="map_arrow down"></i>
                              {openDropDown && (
                                <div
                                  className={`map_dropdown_options ${
                                    openDropDown ? 'show' : ''
                                  }`}
                                >
                                  <ul className="dropdown_items">
                                    {floorMaps?.map((item, index) => (
                                      <li
                                        onClick={() => handleSelectMap(item)}
                                        key={index}
                                      >
                                        {limitLetters(item.image.name, 10)}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            <div
                              className="icon"
                              onClick={() => handleUpdateRoute(mediaMap2D.id)}
                            >
                              <ExpandIcon />
                            </div>
                          </div>
                        )}
                        <div className="map_image">
                          {mapShowed?.image?.url && (
                            <img
                              src={mapShowed.image.url}
                              alt={mapShowed.image.name}
                              onLoad={(e) =>
                                setImageSize({
                                  width: e.target.naturalWidth,
                                  height: e.target.naturalHeight,
                                })
                              }
                            />
                          )}
                          {mapShowed.objects.map((viewpoint) => {
                            const currentPoint =
                              viewpoint.id === currentPano._id;
                            const [left, top] = viewpoint.coordinates;
                            const leftInPercent = left * 100;
                            const topInPercent = top * 100;
                            const currentScene =
                              scenes.find((s) => s._id === viewpoint.id) || {};

                            return (
                              <React.Fragment key={viewpoint.id}>
                                <div
                                  className={`viewpoint-container ${
                                    currentPoint
                                      ? 'current-viewpoint'
                                      : 'viewpoint'
                                  } `}
                                  style={{
                                    left: `${leftInPercent}%`,
                                    top: `${topInPercent}%`,
                                  }}
                                  onClick={() =>
                                    onSelect(
                                      currentScene.groupId,
                                      currentScene.id
                                    )
                                  }
                                ></div>
                                <div
                                  className="circular-sector"
                                  style={{
                                    display: `${
                                      currentPoint ? 'block' : 'none'
                                    }`,
                                    left: `${leftInPercent}%`,
                                    top: `${topInPercent}%`,
                                  }}
                                ></div>
                              </React.Fragment>
                            );
                          })}
                        </div>

                        <div
                          className="mapfloorplan_close"
                          onClick={() => setIsActiveMap(false)}
                        >
                          <button className="mapfloorplan_close-btn">
                            &times;
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>

        {!isMenuGallery && !isSchoolLayout && (
          <>
            {/* <div
              className={`menuV2-mobile--top ${isSimpleLayout ? 'hide' : ''}`}
            >
              <div className="menuV2-mobile--top_line"></div>
            </div> */}
            {/* <div
              className={`menuV2-mobile--header ${
                isSimpleLayout ? 'hide' : ''
              }`}
              onClick={() => toggleMenu(!isNavOpen)}
            >
              <div className="menuV2-mobile--header_icon">
                <PinIcon color={color} />
              </div>
              <div className="menuV2-mobile--header_titles">
                <div
                  className="menuV2-mobile--header_titles_title"
                  style={{ color: color }}
                >
                  {currentPano ? currentPano.title : null}
                </div>
                <p className="menuV2-mobile--header_titles_label">
                  {subTitle ?? null}
                </p>
              </div>
            </div> */}

            {currentPano ? (
              <div
                className="header_titles"
                style={{ position: 'absolute', top: '0', margin: '8px' }}
              >
                <div
                  className="header_titles_title"
                  style={{
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: '700',
                    textShadow:
                      '1px 1px 1px rgba(0, 0, 0, 0.4),-1px -1px 1px rgba(0, 0, 0, 0.2)',
                    textTransform: 'uppercase',
                  }}
                >
                  {limitLetters(currentPano.title, 100)}
                </div>
              </div>
            ) : null}
          </>
        )}
        <PanoMenu
          isOpen={isNavOpen}
          menu={menuList}
          location={menuPosition}
          onClose={() => toggleMenu(false)}
          onSelect={menuOpenScene}
          color={color}
        />
      </div>
      {isMenuGallery && (
        <GalleryMenu
          scenes={scenes}
          mobile={true}
          groups={groups}
          onSelect={onSelect}
          activeColor={color}
          currentPano={currentPano}
          openMenu={openMenu}
          handleOpenMenu={handleOpenMenu}
        />
      )}

      {isSchoolLayout && (
        <SchoolLayoutMenu
          menuList={menuList}
          scenes={scenes}
          mobile={true}
          groups={groups}
          onSelect={onSelect}
          activeColor={color}
          currentPano={currentPano}
          openMenu={openMenu}
          handleOpenMenu={handleOpenMenu}
          isSchoolLayout={isSchoolLayout}
        />
      )}
    </>
  );
};

export default MenuForMobile;
